import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStrongswanComponent } from './simple-icons-strongswan.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStrongswanComponent ],
    exports:      [ SimpleIconsStrongswanComponent ],
    bootstrap:    []
})
export class SimpleIconsStrongswanModule {}
